module.exports = __webpack_public_path__ + "img/list_kdj.b1337f6f.jpg";